import { connect } from 'react-redux';
import RecallParkedReceiptDialogContent from './RecallParkedReceiptDialogContent';
import { bindActionCreators, Dispatch } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { selectors as staffSelectors } from 'ducks/staff';

const mapStateToProps = (state) => ({
    warehouse: staffSelectors.staff(state)?.defaultWarehouseEntity,
    userName: staffSelectors.staff(state)?.name
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RecallParkedReceiptDialogContent);
